import type { Dict } from "@/types/dict";
import { FormInstance } from "./instance";
import type { UseFormProps } from "./types";
import { useFormDebuggerUI } from "./debugger";
import { onHotReload } from "@/utils/debug/onHotreload";

export type UseForm<
  State extends Dict,
  ComputedData extends Dict = Dict,
  ExternalData extends Dict = Dict,
> = FormInstance<State, ComputedData, ExternalData>;

export const useForm = <
  State extends Dict,
  ComputedData extends Dict = Dict,
  ExternalData extends Dict = Dict,
>(
  props: UseFormProps<State, ComputedData, ExternalData>,
): FormInstance<State, ComputedData, ExternalData> => {
  const form = new FormInstance<State, ComputedData, ExternalData>(props);
  useFormDebuggerUI(form);

  onHotReload(() => {
    console.log("FORM UPDATE");
    form.update();
    form.resetState();
    form.clearErrors();
  });
  return form;
};
